export const translation = {
  zenit: {
    ae: {
      siteTitle: 'مكافآتك | Zenit',
      title1: 'شاهد البث',
      title2: 'المباشر',
      subtitleTextExtra: 'أكثر من',
      subtitleNumber: '%100',
      subtitleText: 'من قيمة أول إيداعاتك',
      subtitleSumText: 'حتى',
      btnSignup: 'سجّل',
      stepTitle1: 'سجّل',
      stepText1: 'أكمل التسجيل السريع',
      stepTitle2: 'إيداع',
      stepText2: 'أودع باستخدام أي وسيلة متاحة.',
      stepTitle3: 'احصل على مكافأة',
      stepText3: 'احصل على مكافأة وشاهد البث المباشر',
      offerTitle: 'نقدم',
      offerItem1: 'أكثر من 1000 حدث كل يوم',
      offerItem2: 'تسويات الرهانات السريعة',
      offerItem3: 'دعم 24 ساعة على مدار الأسبوع',
      offerItem4: 'البث المباشر عبر تطبيقنا للأندرويد',
      offerItem5: 'إيداعات سهلة',
      promoCodeText: 'رمز ترويجي',
      regFormTitle: `Register
        and make bets!`
    },
    bn: {
      siteTitle: 'আপনার বোনাস | Zenit',
      title1: 'সরাসরি',
      title2: 'সম্প্রচার দেখুন',
      subtitleNumber: '+100%',
      subtitleText: 'আপনার প্রথম আমানতের',
      subtitleSumText: 'পর্যন্ত\xA0',
      btnSignup: 'নিবন্ধন করুন',
      stepTitle1: 'নিবন্ধন করুন',
      stepText1: 'দ্রুত নিবন্ধন সম্পন্ন করুন',
      stepTitle2: 'জমা করুন',
      stepText2: 'যেকোনো উপলভ্য পদ্ধতি ব্যবহার করে জমা করুন।',
      stepTitle3: 'বোনাস পান',
      stepText3: 'বোনাস পান এবং সরাসরি সম্প্রচার দেখুন',
      offerTitle: 'আমরা প্রদান করছি',
      offerItem1: 'প্রতিদিন 1000 টিরও বেশি ইভেন্ট',
      offerItem2: 'দ্রুত বাজি নিষ্পত্তি',
      offerItem3: '24/7 সহায়তা',
      offerItem4: 'আমাদের অ্যান্ড্রয়েড অ্যাপের মাধ্যমে সরাসরি সম্প্রচার',
      offerItem5: 'সহজ আমানত',
      promoCodeText: 'প্রোমো কোড',
      regFormTitle: `Register
        and make bets!`
    },
    br: {
      siteTitle: 'Seus bônus | Zenit',
      title1: 'VEJA ',
      title2: 'TRANSMISSÕES AO VIVO',
      subtitleNumber: '+100%',
      subtitleText: ' DO SEU PRIMEIRO DEPÓSITO',
      subtitleSumText: 'ATÉ',
      btnSignup: 'REGISTRE-SE',
      stepTitle1: 'Registre-se',
      stepText1: 'Complete um registro rápido',
      stepTitle2: 'Depósito',
      stepText2: `Faça um depósito usando
        qualquer método disponível`,
      stepTitle3: 'Obtenha um bônus',
      stepText3: 'Obtenha um bônus e assista a transmissões ao vivo',
      offerTitle: 'Oferecemos',
      offerItem1: 'Mais de 1000 eventos todos os dias',
      offerItem2: 'Liquidações rápidas de apostas',
      offerItem3: 'Suporte 24h',
      offerItem4: 'Transmissões ao vivo em nosso aplicativo para Android',
      offerItem5: 'Depósitos simples',
      promoCodeText: 'Código promocional',
      regFormTitle: `REGISTRE-SE
        E FAÇA APOSTAS!`
    },
    de: {
      siteTitle: 'Ihre Boni | Zenit',
      title1: 'LIVE',
      title2: 'ÜBERTRAGUNGEN ANSEHEN',
      subtitleNumber: '+100%',
      subtitleText: 'AUF IHRE ERSTE EINZAHLUNG',
      subtitleSumText: 'Bis zu',
      btnSignup: 'Registrieren',
      stepTitle1: 'Registrieren',
      stepText1: 'Schnellregistrierung',
      stepTitle2: 'Einzahlung',
      stepText2: `Tätigen Sie eine Einzahlung
        mit einer der verfügbaren Methoden.`,
      stepTitle3: 'Bonus erhalten',
      stepText3: 'Bonus erhalten und Live-Übertragungen ansehen',
      offerTitle: 'Wir bieten',
      offerItem1: 'Täglich über 1.000 Ereignisse',
      offerItem2: 'Schnelle Wettabrechnung',
      offerItem3: '24/7-Support',
      offerItem4: 'Live-Übertragungen über unsere Android-App',
      offerItem5: 'Einfache Einzahlungen',
      promoCodeText: 'Aktionscode',
      regFormTitle: `Register
        and make bets!`
    },
    en: {
      siteTitle: 'Your bonuses | Zenit',
      title1: 'VIEW',
      title2: 'LIVE BROADCASTS',
      subtitleNumber: '+100%',
      subtitleText: 'OF YOUR FIRST DEPOSIT',
      subtitleSumText: 'Up to',
      btnSignup: 'REGISTER',
      stepTitle1: 'Register',
      stepText1: 'Complete quick registration',
      stepTitle2: 'Deposit',
      stepText2: 'Make a deposit using any available method',
      stepTitle3: 'Get bonus',
      stepText3: 'Get bonus and watch live broadcasts',
      offerTitle: 'We offer',
      offerItem1: 'Over 1000 events every day',
      offerItem2: 'Quick bet settlements',
      offerItem3: '24/7 support',
      offerItem4: 'Live broadcasts through our Android app',
      offerItem5: 'Simple deposits',
      promoCodeText: 'Promo code',
      regFormTitle: `Register
        and make bets!`
    },
    fr: {
      siteTitle: 'Vos bonus | Zenit',
      title1: 'AFFICHER',
      title2: 'LES DIFFUSIONS EN DIRECT',
      subtitleTextExtra: 'PLUS DE',
      subtitleNumber: '100%',
      subtitleText: 'DE VOTRE PREMIER DÉPÔT',
      subtitleSumText: `Jusqu'à`,
      btnSignup: `S'enregistrer`,
      stepTitle1: `S'enregistrer`,
      stepText1: `Procéder à l'enregistrement rapide`,
      stepTitle2: 'Dépôt',
      stepText2: `Effectuez un dépôt à l'aide
        de l'un des modes de dépôt disponibles.`,
      stepTitle3: 'Obtenir un bonus',
      stepText3: 'Obtenez des bonus et regardez des diffusions en direct',
      offerTitle: 'Nous proposons',
      offerItem1: 'Plus de 1 000 événements par jour',
      offerItem2: 'Placements de paris rapides',
      offerItem3: 'Assistance 24/7',
      offerItem4: 'Diffusions en direct par le biais de notre application pour Android',
      offerItem5: 'Simplicité des dépôts',
      promoCodeText: 'Code promotionnel',
      regFormTitle: `Register
        and make bets!`
    },
    ir: {
      siteTitle: 'پاداش‌های شما | Zenit',
      title1: 'ورزشی زنده',
      title2: 'تماشای رویدادهای',
      subtitleNumber: '+100%',
      subtitleText: 'بیشتر از اولین واریز شما',
      subtitleSumText: 'تا حداکثر',
      btnSignup: 'ثبت‌نام',
      stepTitle1: 'ثبت‌نام',
      stepText1: 'ثبت‌نام کامل و سریع',
      stepTitle2: 'واریز',
      stepText2: 'با استفاده از هر روش پرداختی',
      stepTitle3: 'دریافت پاداش',
      stepText3: 'و تماشای پخش زنده',
      offerTitle: 'ما روزانه',
      offerItem1: 'بیش از 1000 رویداد ارائه می‌کنیم',
      offerItem2: 'تسویه سریع شرط‌ها',
      offerItem3: 'پشتیبانی هر روزه و همه ساعته',
      offerItem4: 'پخش زنده از طریق برنامه اندروید',
      offerItem5: 'واریز آسان',
      promoCodeText: 'Promo code',
      regFormTitle: `Register
        and make bets!`
    },
    kz: {
      siteTitle: 'Сенің бонустарың | БК Зенит',
      title1: 'МАТЧ',
      title2: 'ТРАНСЛЯЦИЯЛАРЫН ҚАРА',
      subtitleNumber: '+100%',
      subtitleText: 'АЛҒАШҚЫ ТОЛЫҚТЫРУҒА ',
      subtitleSumText: 'дейін',
      btnSignup: 'ТІРКЕЛУ',
      stepTitle1: 'Тіркел',
      stepText1: 'Жылдам тіркелуден өт',
      stepTitle2: 'Шотты толықтыр',
      stepText2: 'Кез келген қолайлы тәсілмен депозитке салым жаса',
      stepTitle3: 'Бонус ал',
      stepText3: 'Бонус ал да, матчты тікелей эфирде қара',
      offerTitle: 'Біз ұсынамыз',
      offerItem1: 'Күн сайын 1000-нан астам оқиға',
      offerItem2: 'Бәсті жылдам есептеу',
      offerItem3: '24/7 қолдау',
      offerItem4: 'Android-қолданбадағы көрсетілім',
      offerItem5: 'Қолайлы толықтырулар',
      promoCodeText: 'Промокод',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    mx: {
      siteTitle: 'Sus bonificaciones | Zenit',
      title1: 'VER',
      title2: 'TRANSMISIONES EN DIRECTO',
      subtitleNumber: 'DE 100%',
      subtitleText: 'DE SU PRIMER DEPÓSITO',
      subtitleSumText: 'Hasta',
      btnSignup: 'Registrar',
      stepTitle1: 'Registrar',
      stepText1: 'Completa registro rápido',
      stepTitle2: 'Depósito',
      stepText2: 'Hacer un depóstio mediante cualquier método disponible.',
      stepTitle3: 'Obtenga una bonificación',
      stepText3: 'Obtenga bonificaciones y vea emisiones en vivo',
      offerTitle: 'Ofrecemos',
      offerItem1: 'Más de 1000 eventos al día',
      offerItem2: 'Rápida liquidación de apuestas',
      offerItem3: 'Las 24 horas del día, los 7 días de la semana',
      offerItem4: 'Emisiones en directo a través de nuestra aplicación de Android',
      offerItem5: 'Depósitos sencillos',
      promoCodeText: 'Código promocional',
      regFormTitle: `Register
        and make bets!`
    },
    ru: {
      siteTitle: 'Бонус до 30 000 рублей | БК Зенит',
      title1: 'Смотри',
      title2: 'трансляции матчей',
      subtitleNumber: '+100%',
      subtitleText: 'на первое пополнение',
      subtitleSumText: 'До',
      btnSignup: 'Зарегистрироваться',
      stepTitle1: 'Зарегистрируйся',
      stepText1: 'Пройди быструю регистрацию',
      stepTitle2: 'Пополни счет',
      stepText2: 'Внеси депозит любым удобным способом',
      stepTitle3: 'Получи бонус',
      stepText3: 'Получи бонус и смотри матчи в прямом эфире',
      offerTitle: 'Мы предлагаем',
      offerItem1: 'Более 1000 событий каждый день',
      offerItem2: 'Быстрый расчет ставок',
      offerItem3: 'Поддержку 24/7',
      offerItem4: 'Трансляции в android-приложении',
      offerItem5: 'Удобные пополнения',
      promoCodeText: 'Промокод',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    sw: {
      siteTitle: 'Bonasi zako | Zenit',
      title1: 'TAZAMA',
      title2: 'PROGRAMU ZA MOJA KWA MOJA',
      subtitleNumber: '100%',
      subtitleText: 'ZA PESA ZA KWANZA UNAZOWEKA',
      subtitleSumText: 'Hadi kiasi cha ',
      btnSignup: 'Jisajili',
      stepTitle1: 'Jisajili',
      stepText1: 'Kamilisha usajili wa haraka',
      stepTitle2: 'Kuweka pesa',
      stepText2: 'Weka pesa kupitia njia yoyote inayopatikana.',
      stepTitle3: 'Pokea bonasi',
      stepText3: 'Pokea bonasi na utazame moja kwa moja mtandaoni',
      offerTitle: 'Tunaandaa',
      offerItem1: 'Zaidi ya matukio 1000 kila siku',
      offerItem2: 'Kuamuliwa haraka kwa dau',
      offerItem3: 'Tunakusaidia 24/7',
      offerItem4: 'Upeperushaji wa moja kwa moja kupitia programu yetu ya Android',
      offerItem5: 'Kuweka pesa kwa njia rahisi',
      promoCodeText: 'Msimbo wa promosheni',
      regFormTitle: `Register
        and make bets!`
    },
    tr: {
      siteTitle: 'Bonuslarınız | Zenit',
      title1: 'CANLI',
      title2: 'YAYINLARI İZLEYİN',
      subtitleTextExtra: 'İLK YATIRDIĞINIZ PARANIN',
      subtitleNumber: `+%\xA0100'Ü`,
      subtitleText: '',
      subtitleSumText: 'kadar',
      btnSignup: 'Зарегистрироваться',
      stepTitle1: 'Kaydolun',
      stepText1: 'Hızlı kaydı tamamlayın',
      stepTitle2: 'Para Yatırma',
      stepText2: 'Herhangi bir yöntemi kullanarak para yatırın.',
      stepTitle3: 'Bonus al',
      stepText3: 'Bonus alın ve canlı yayınları izleyin',
      offerTitle: 'Şunları sunuyoruz',
      offerItem1: `Her gün 1000'den fazla etkinlik`,
      offerItem2: 'Hızlı bahis sonuçları',
      offerItem3: '7/24 destek',
      offerItem4: 'Android uygulamamız aracılığıyla canlı yayınlar',
      offerItem5: 'Basit para yatırma işlemleri',
      promoCodeText: 'Promosyon kodu',
      regFormTitle: `Register
        and make bets!`
    },
    ua: {
      siteTitle: 'Бонус до 11 000 гривен | БК ZENIT',
      title1: 'Смотри',
      title2: 'трансляции матчей',
      subtitleNumber: '+100%',
      subtitleText: 'на первое пополнение',
      subtitleSumText: 'До',
      btnSignup: 'Зарегистрироваться',
      stepTitle1: 'Зарегистрируйся',
      stepText1: 'Пройди быструю регистрацию',
      stepTitle2: 'Пополни счет',
      stepText2: 'Внеси депозит любым удобным способом',
      stepTitle3: 'Получи бонус',
      stepText3: 'Получи бонус и смотри матчи в прямом эфире',
      offerTitle: 'Мы предлагаем',
      offerItem1: 'Более 1000 событий каждый день',
      offerItem2: 'Быстрый расчет ставок',
      offerItem3: 'Поддержку 24/7',
      offerItem4: 'Трансляции в android-приложении',
      offerItem5: 'Удобные пополнения',
      promoCodeText: 'Промокод',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    uz: {
      siteTitle: 'Bonuslaring | Zenit',
      title1: 'MATCHLARNING',
      title2: 'TRANSLYATSIYALARINI KO‘R',
      subtitleNumber: '+100%',
      subtitleText: 'BIRINCHI TO‘LDIRISHGA',
      subtitleSumText: '',
      btnSignup: 'Ro‘yxatdan o‘t',
      stepTitle1: 'Ro‘yxatdan o‘t',
      stepText1: 'Tezkor ro‘yxatdan o‘t',
      stepTitle2: 'Hisobni to‘ldir',
      stepText2: 'Istalgan qulay usul bilan depozit kirit',
      stepTitle3: 'Bonus ol',
      stepText3: 'Bonus ol va matchlarni to‘g‘ridan-to‘g‘ri efirda ko‘r',
      offerTitle: 'Biz taklif qilamiz',
      offerItem1: 'Har kuni 1000 dan ortiq hodisa',
      offerItem2: 'Stavkalarning tezkor hisoblash',
      offerItem3: '24/7 rejimidagi qo‘llab-quvvatlash',
      offerItem4: 'Android-ilovasidagi translyatsiyalar',
      offerItem5: 'Qulay to‘ldirishlar',
      promoCodeText: 'Promokod',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | Zenit',
      title1: 'XEM PHÁT',
      title2: 'TRỰC TUYẾN',
      subtitleNumber: '100%',
      subtitleText: 'TRONG LẦN NẠP TIỀN ĐẦU TIÊN',
      subtitleSumText: 'Lên đến',
      btnSignup: 'Đăng ký',
      stepTitle1: 'Đăng ký',
      stepText1: 'Hoàn tất quy trình đăng ký nhanh',
      stepTitle2: 'Nạp tiền',
      stepText2: 'Nạp tiền bằng bất kỳ phương thức nào có sẵn',
      stepTitle3: 'Nhận tiền thưởng',
      stepText3: 'Nhận tiền thưởng và xem phát trực tiếp',
      offerTitle: 'Chúng tôi cung cấp',
      offerItem1: 'Trên 100 sự kiện mỗi ngày',
      offerItem2: 'Thanh toán cược nhanh',
      offerItem3: 'Hỗ trợ 24/7',
      offerItem4: 'Phát trực tiếp thông qua ứng dụng Android',
      offerItem5: 'Quy trình nạp tiền đơn giản',
      promoCodeText: 'Mã khuyến mãi',
      regFormTitle: `Register
        and make bets!`
    }
  },
  zenbet: {
    ae: {
      siteTitle: 'مكافآتك | ZENBET',
      title1: 'شاهد البث',
      title2: 'المباشر',
      subtitleTextExtra: 'أكثر من',
      subtitleNumber: '%100',
      subtitleText: 'من قيمة أول إيداعاتك',
      subtitleSumText: 'حتى',
      btnSignup: 'سجّل',
      stepTitle1: 'سجّل',
      stepText1: 'أكمل التسجيل السريع',
      stepTitle2: 'إيداع',
      stepText2: 'أودع باستخدام أي وسيلة متاحة.',
      stepTitle3: 'احصل على مكافأة',
      stepText3: 'احصل على مكافأة وشاهد البث المباشر',
      offerTitle: 'نقدم',
      offerItem1: 'أكثر من 1000 حدث كل يوم',
      offerItem2: 'تسويات الرهانات السريعة',
      offerItem3: 'دعم 24 ساعة على مدار الأسبوع',
      offerItem4: 'البث المباشر عبر تطبيقنا للأندرويد',
      offerItem5: 'إيداعات سهلة',
      promoCodeText: 'رمز ترويجي',
      regFormTitle: `Register
        and make bets!`
    },
    bn: {
      siteTitle: 'আপনার বোনাস | ZENBET',
      title1: 'সরাসরি',
      title2: 'সম্প্রচার দেখুন',
      subtitleNumber: '+100%',
      subtitleText: 'আপনার প্রথম আমানতের',
      subtitleSumText: 'পর্যন্ত\xA0',
      btnSignup: 'নিবন্ধন করুন',
      stepTitle1: 'নিবন্ধন করুন',
      stepText1: 'দ্রুত নিবন্ধন সম্পন্ন করুন',
      stepTitle2: 'জমা করুন',
      stepText2: 'যেকোনো উপলভ্য পদ্ধতি ব্যবহার করে জমা করুন।',
      stepTitle3: 'বোনাস পান',
      stepText3: 'বোনাস পান এবং সরাসরি সম্প্রচার দেখুন',
      offerTitle: 'আমরা প্রদান করছি',
      offerItem1: 'প্রতিদিন 1000 টিরও বেশি ইভেন্ট',
      offerItem2: 'দ্রুত বাজি নিষ্পত্তি',
      offerItem3: '24/7 সহায়তা',
      offerItem4: 'আমাদের অ্যান্ড্রয়েড অ্যাপের মাধ্যমে সরাসরি সম্প্রচার',
      offerItem5: 'সহজ আমানত',
      promoCodeText: 'প্রোমো কোড',
      regFormTitle: `Register
        and make bets!`
    },
    br: {
      siteTitle: 'Seus bônus | ZENBET',
      title1: 'VEJA',
      title2: 'TRANSMISSÕES AO VIVO',
      subtitleNumber: '+100%',
      subtitleText: ' DO SEU PRIMEIRO DEPÓSITO',
      subtitleSumText: 'ATÉ',
      btnSignup: 'REGISTRE-SE',
      stepTitle1: 'Registre-se',
      stepText1: 'Complete um registro rápido',
      stepTitle2: 'Depósito',
      stepText2: 'Faça um depósito usando qualquer método disponível',
      stepTitle3: 'Obtenha um bônus',
      stepText3: 'Obtenha um bônus e assista a transmissões ao vivo',
      offerTitle: 'Oferecemos',
      offerItem1: 'Mais de 1000 eventos todos os dias',
      offerItem2: 'Liquidações rápidas de apostas',
      offerItem3: 'Suporte 24h',
      offerItem4: 'Transmissões ao vivo em nosso aplicativo para Android',
      offerItem5: 'Depósitos simples',
      promoCodeText: 'Código promocional',
      regFormTitle: `REGISTRE-SE
        E FAÇA APOSTAS!`
    },
    de: {
      siteTitle: 'Ihre Boni | ZENBET',
      title1: 'LIVE',
      title2: 'ÜBERTRAGUNGEN ANSEHEN',
      subtitleNumber: '+100%',
      subtitleText: 'AUF IHRE ERSTE EINZAHLUNG',
      subtitleSumText: 'Bis zu',
      btnSignup: 'Registrieren',
      stepTitle1: 'Registrieren',
      stepText1: 'Schnellregistrierung',
      stepTitle2: 'Einzahlung',
      stepText2: `Tätigen Sie eine Einzahlung
        mit einer der verfügbaren Methoden.`,
      stepTitle3: 'Bonus erhalten',
      stepText3: 'Bonus erhalten und Live-Übertragungen ansehen',
      offerTitle: 'Wir bieten',
      offerItem1: 'Täglich über 1.000 Ereignisse',
      offerItem2: 'Schnelle Wettabrechnung',
      offerItem3: '24/7-Support',
      offerItem4: 'Live-Übertragungen über unsere Android-App',
      offerItem5: 'Einfache Einzahlungen',
      promoCodeText: 'Aktionscode',
      regFormTitle: `Register
        and make bets!`
    },
    en: {
      siteTitle: 'Your bonuses | ZENBET',
      title1: 'VIEW',
      title2: 'LIVE BROADCASTS',
      subtitleNumber: '+100%',
      subtitleText: 'OF YOUR FIRST DEPOSIT',
      subtitleSumText: 'Up to',
      btnSignup: 'REGISTER',
      stepTitle1: 'Register',
      stepText1: 'Complete quick registration',
      stepTitle2: 'Deposit',
      stepText2: 'Make a deposit using any available method',
      stepTitle3: 'Get bonus',
      stepText3: 'Get bonus and watch live broadcasts',
      offerTitle: 'We offer',
      offerItem1: 'Over 1000 events every day',
      offerItem2: 'Quick bet settlements',
      offerItem3: '24/7 support',
      offerItem4: 'Live broadcasts through our Android app',
      offerItem5: 'Simple deposits',
      promoCodeText: 'Promo code',
      regFormTitle: `Register
        and make bets!`
    },
    fr: {
      siteTitle: 'Vos bonus | ZENBET',
      title1: 'AFFICHER',
      title2: 'LES DIFFUSIONS EN DIRECT',
      subtitleTextExtra: 'PLUS DE',
      subtitleNumber: '100%',
      subtitleText: 'DE VOTRE PREMIER DÉPÔT',
      subtitleSumText: `Jusqu'à`,
      btnSignup: `S'enregistrer`,
      stepTitle1: `S'enregistrer`,
      stepText1: `Procéder à l'enregistrement rapide`,
      stepTitle2: 'Dépôt',
      stepText2: `Effectuez un dépôt à l'aide
        de l'un des modes de dépôt disponibles.`,
      stepTitle3: 'Obtenir un bonus',
      stepText3: 'Obtenez des bonus et regardez des diffusions en direct',
      offerTitle: 'Nous proposons',
      offerItem1: 'Plus de 1 000 événements par jour',
      offerItem2: 'Placements de paris rapides',
      offerItem3: 'Assistance 24/7',
      offerItem4: 'Diffusions en direct par le biais de notre application pour Android',
      offerItem5: 'Simplicité des dépôts',
      promoCodeText: 'Code promotionnel',
      regFormTitle: `Register
        and make bets!`
    },
    ir: {
      siteTitle: 'پاداش‌های شما ZENBET',
      title1: 'ورزشی زنده',
      title2: 'تماشای رویدادهای',
      subtitleNumber: '+100%',
      subtitleText: 'بیشتر از اولین واریز شما',
      subtitleSumText: 'تا حداکثر',
      btnSignup: 'ثبت‌نام',
      stepTitle1: 'ثبت‌نام',
      stepText1: 'ثبت‌نام کامل و سریع',
      stepTitle2: 'واریز',
      stepText2: 'با استفاده از هر روش پرداختی',
      stepTitle3: 'دریافت پاداش',
      stepText3: 'و تماشای پخش زنده',
      offerTitle: 'ما روزانه',
      offerItem1: 'بیش از 1000 رویداد ارائه می‌کنیم',
      offerItem2: 'تسویه سریع شرط‌ها',
      offerItem3: 'پشتیبانی هر روزه و همه ساعته',
      offerItem4: 'پخش زنده از طریق برنامه اندروید',
      offerItem5: 'واریز آسان',
      promoCodeText: 'Promo code',
      regFormTitle: `Register
        and make bets!`
    },
    kz: {
      siteTitle: 'Сенің бонустарың | БК ZENBET',
      title1: 'МАТЧ',
      title2: 'ТРАНСЛЯЦИЯЛАРЫН ҚАРА',
      subtitleNumber: '+100%',
      subtitleText: 'АЛҒАШҚЫ ТОЛЫҚТЫРУҒА ',
      subtitleSumText: 'дейін',
      btnSignup: 'ТІРКЕЛУ',
      stepTitle1: 'Тіркел',
      stepText1: 'Жылдам тіркелуден өт',
      stepTitle2: 'Шотты толықтыр',
      stepText2: 'Кез келген қолайлы тәсілмен депозитке салым жаса',
      stepTitle3: 'Бонус ал',
      stepText3: 'Бонус ал да, матчты тікелей эфирде қара',
      offerTitle: 'Біз ұсынамыз',
      offerItem1: 'Күн сайын 1000-нан астам оқиға',
      offerItem2: 'Бәсті жылдам есептеу',
      offerItem3: '24/7 қолдау',
      offerItem4: 'Android-қолданбадағы көрсетілім',
      offerItem5: 'Қолайлы толықтырулар',
      promoCodeText: 'Промокод',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    mx: {
      siteTitle: 'Sus bonificaciones | ZENBET',
      title1: 'VER',
      title2: 'TRANSMISIONES EN DIRECTO',
      subtitleNumber: 'DE 100%',
      subtitleText: 'DE SU PRIMER DEPÓSITO',
      subtitleSumText: 'Hasta',
      btnSignup: 'Registrar',
      stepTitle1: 'Registrar',
      stepText1: 'Completa registro rápido',
      stepTitle2: 'Depósito',
      stepText2: 'Hacer un depóstio mediante cualquier método disponible.',
      stepTitle3: 'Obtenga una bonificación',
      stepText3: 'Obtenga bonificaciones y vea emisiones en vivo',
      offerTitle: 'Ofrecemos',
      offerItem1: 'Más de 1000 eventos al día',
      offerItem2: 'Rápida liquidación de apuestas',
      offerItem3: 'Las 24 horas del día, los 7 días de la semana',
      offerItem4: 'Emisiones en directo a través de nuestra aplicación de Android',
      offerItem5: 'Depósitos sencillos',
      promoCodeText: 'Código promocional',
      regFormTitle: `Register
        and make bets!`
    },
    ru: {
      siteTitle: 'Твои бонусы | БК ZENBET',
      title1: 'Смотри',
      title2: 'трансляции матчей',
      subtitleNumber: '+100%',
      subtitleText: 'на первое пополнение',
      subtitleSumText: 'До',
      btnSignup: 'Зарегистрироваться',
      stepTitle1: 'Зарегистрируйся',
      stepText1: 'Пройди быструю регистрацию',
      stepTitle2: 'Пополни счет',
      stepText2: 'Внеси депозит любым удобным способом',
      stepTitle3: 'Получи бонус',
      stepText3: 'Получи бонус и смотри матчи в прямом эфире',
      offerTitle: 'Мы предлагаем',
      offerItem1: 'Более 1000 событий каждый день',
      offerItem2: 'Быстрый расчет ставок',
      offerItem3: 'Поддержку 24/7',
      offerItem4: 'Трансляции в android-приложении',
      offerItem5: 'Удобные пополнения',
      promoCodeText: 'Промокод',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    sw: {
      siteTitle: 'Bonasi zako | ZENBET',
      title1: 'TAZAMA',
      title2: 'PROGRAMU ZA MOJA KWA MOJA',
      subtitleNumber: '100%',
      subtitleText: 'ZA PESA ZA KWANZA UNAZOWEKA',
      subtitleSumText: 'Hadi kiasi cha ',
      btnSignup: 'Jisajili',
      stepTitle1: 'Jisajili',
      stepText1: 'Kamilisha usajili wa haraka',
      stepTitle2: 'Kuweka pesa',
      stepText2: 'Weka pesa kupitia njia yoyote inayopatikana.',
      stepTitle3: 'Pokea bonasi',
      stepText3: 'Pokea bonasi na utazame moja kwa moja mtandaoni',
      offerTitle: 'Tunaandaa',
      offerItem1: 'Zaidi ya matukio 1000 kila siku',
      offerItem2: 'Kuamuliwa haraka kwa dau',
      offerItem3: 'Tunakusaidia 24/7',
      offerItem4: 'Upeperushaji wa moja kwa moja kupitia programu yetu ya Android',
      offerItem5: 'Kuweka pesa kwa njia rahisi',
      promoCodeText: 'Msimbo wa promosheni',
      regFormTitle: `Register
        and make bets!`
    },
    tr: {
      siteTitle: 'Bonuslarınız | ZENBET',
      title1: 'CANLI',
      title2: 'YAYINLARI İZLEYİN',
      subtitleTextExtra: 'İLK YATIRDIĞINIZ PARANIN',
      subtitleNumber: `+%\xA0100'Ü`,
      subtitleText: '',
      subtitleSumText: 'kadar',
      btnSignup: 'Зарегистрироваться',
      stepTitle1: 'Kaydolun',
      stepText1: 'Hızlı kaydı tamamlayın',
      stepTitle2: 'Para Yatırma',
      stepText2: 'Herhangi bir yöntemi kullanarak para yatırın.',
      stepTitle3: 'Bonus al',
      stepText3: 'Bonus alın ve canlı yayınları izleyin',
      offerTitle: 'Şunları sunuyoruz',
      offerItem1: `Her gün 1000'den fazla etkinlik`,
      offerItem2: 'Hızlı bahis sonuçları',
      offerItem3: '7/24 destek',
      offerItem4: 'Android uygulamamız aracılığıyla canlı yayınlar',
      offerItem5: 'Basit para yatırma işlemleri',
      promoCodeText: 'Promosyon kodu',
      regFormTitle: `Register
        and make bets!`
    },
    uz: {
      siteTitle: 'Bonuslaring | БК ZENBET',
      title1: 'MATCHLARNING',
      title2: 'TRANSLYATSIYALARINI KO‘R',
      subtitleNumber: '+100%',
      subtitleText: 'BIRINCHI TO‘LDIRISHGA',
      subtitleSumText: '',
      btnSignup: 'Ro‘yxatdan o‘t',
      stepTitle1: 'Ro‘yxatdan o‘t',
      stepText1: 'Tezkor ro‘yxatdan o‘t',
      stepTitle2: 'Hisobni to‘ldir',
      stepText2: 'Istalgan qulay usul bilan depozit kirit',
      stepTitle3: 'Bonus ol',
      stepText3: 'Bonus ol va matchlarni to‘g‘ridan-to‘g‘ri efirda ko‘r',
      offerTitle: 'Biz taklif qilamiz',
      offerItem1: 'Har kuni 1000 dan ortiq hodisa',
      offerItem2: 'Stavkalarning tezkor hisoblash',
      offerItem3: '24/7 rejimidagi qo‘llab-quvvatlash',
      offerItem4: 'Android-ilovasidagi translyatsiyalar',
      offerItem5: 'Qulay to‘ldirishlar',
      promoCodeText: 'Promokod',
      regFormTitle: `Зарегистрируйся
        и делай ставки!`
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | ZENBET',
      title1: 'XEM PHÁT',
      title2: 'TRỰC TUYẾN',
      subtitleNumber: '100%',
      subtitleText: 'TRONG LẦN NẠP TIỀN ĐẦU TIÊN',
      subtitleSumText: 'Lên đến',
      btnSignup: 'Đăng ký',
      stepTitle1: 'Đăng ký',
      stepText1: 'Hoàn tất quy trình đăng ký nhanh',
      stepTitle2: 'Nạp tiền',
      stepText2: 'Nạp tiền bằng bất kỳ phương thức nào có sẵn',
      stepTitle3: 'Nhận tiền thưởng',
      stepText3: 'Nhận tiền thưởng và xem phát trực tiếp',
      offerTitle: 'Chúng tôi cung cấp',
      offerItem1: 'Trên 100 sự kiện mỗi ngày',
      offerItem2: 'Thanh toán cược nhanh',
      offerItem3: 'Hỗ trợ 24/7',
      offerItem4: 'Phát trực tiếp thông qua ứng dụng Android',
      offerItem5: 'Quy trình nạp tiền đơn giản',
      promoCodeText: 'Mã khuyến mãi',
      regFormTitle: `Register
        and make bets!`
    }
  }
}